import { ListItemIcon } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import DashboardIcon from "@material-ui/icons/Dashboard";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { showSidebar } from "../../../redux/actions/sidebarActions";

export default function Dashboard({ link }) {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <ListItem
      button
      onClick={() => {
        history.push(link || "/dashboard");
        dispatch(showSidebar(false));
      }}
    >
      <ListItemIcon>
        <DashboardIcon />
      </ListItemIcon>
      <ListItemText primary={t("mainSideBar.dashboard")} />
    </ListItem>
  );
}
